/**
 * A24-style collection filters.
 *
 * A24 hides the filter panel by default and shows a FILTERS toggle above a
 * full-width 4-column product grid. Opening it turns the panel into the first
 * grid column (one card-width wide) and reflows the products to 3 columns.
 * Dawn instead renders a permanently visible sidebar, so this wires the toggle
 * and marks the shared parent so CSS can do the column switch.
 *
 * Progressive enhancement: with JS off, .a24-collection-layout is never added
 * and Dawn's own always-visible sidebar remains, which still works.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'a24-filters-open';
  var LAYOUT_CLASS = 'a24-collection-layout';

  function init() {
    var facets = document.querySelector('.facets-wrapper');
    var grid = document.querySelector('.product-grid-container');
    if (!facets || !grid || facets.parentElement !== grid.parentElement) return;

    var layout = facets.parentElement;
    if (layout.classList.contains(LAYOUT_CLASS)) return;
    layout.classList.add(LAYOUT_CLASS);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'a24-filters-toggle a24-label';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', facets.id || 'FacetsWrapperDesktop');
    toggle.textContent = layout.dataset.a24FiltersLabel || 'Filters';

    layout.insertBefore(toggle, facets);

    toggle.addEventListener('click', function () {
      var open = layout.classList.toggle(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Dawn re-renders the grid on filter/sort changes; re-attach if our node went away.
  document.addEventListener('shopify:section:load', init);
  var target = document.getElementById('ProductGridContainer');
  if (target && window.MutationObserver) {
    new MutationObserver(function () {
      if (!document.querySelector('.a24-filters-toggle')) init();
    }).observe(target, { childList: true, subtree: true });
  }
})();
